import {
  initTable,
  formatNameHeaderColumn,
  addPointInteger,
  downloadPDFTable,
  downloadCSVTable,
} from 'vlcishared';
import { DEFAULT_LANGUAGE } from '../common-language';
import { TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL } from './texts';

const UNIDAD_ADMIN = 'unidad';
const TAREAS_REALIZADAS = 'total_tareas_realizadas';
const TAREAS_PENDIENTES = 'total_tareas_pendientes';
const CARGA_ADMIN = 'carga_administrativa';
const NUM_USUARIOS = 'numero_usuarios';
const NOMBRE_FICHERO = 'Tareas por Unidad Administrativa';

const commonObjectMetric = {
  titleFormatter: (cell) => formatNameHeaderColumn(cell, 20),
  headerSort: false,
  sorter: 'string',
  width: '18%',
  hozAlign: 'center',
  headerHozAlign: 'center',
  formatter: function formatDecimal(cell) {
    return addPointInteger(cell.getValue());
  },
};

const columnasTabla = [
  {
    title: TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
      'unidad_administrativa',
    ),
    field: UNIDAD_ADMIN,
    width: '30%',
    hozAlign: 'center',
    headerHozAlign: 'center',
    frozen: true,
    headerSort: false,
  },
  {
    title:
      TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
        'tareas_realizadas',
      ),
    field: TAREAS_REALIZADAS,
    ...commonObjectMetric,
  },
  {
    title:
      TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
        'tareas_pendientes',
      ),
    field: TAREAS_PENDIENTES,
    ...commonObjectMetric,
  },
  {
    title: TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
      'carga_administrativa',
    ),
    field: CARGA_ADMIN,
    ...commonObjectMetric,
  },
  {
    title:
      TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
        'num_usuarios',
      ),
    field: NUM_USUARIOS,
    ...commonObjectMetric,
  },
];

export async function echartTablaTareasPorUA(datos) {
  const dataObj = datos.resultset.map((item) => ({
    [UNIDAD_ADMIN]: item[0],
    [TAREAS_REALIZADAS]: item[1],
    [TAREAS_PENDIENTES]: item[2],
    [CARGA_ADMIN]: item[3],
    [NUM_USUARIOS]: item[4],
  }));
  const option = {
    height: '100%',
    scrollable: true,
    layout: 'fitDataTable',
    columns: columnasTabla,
    data: dataObj,
  };

  const table = await initTable('tablaUA', option);

  downloadCSVTable(table, NOMBRE_FICHERO, 'download-csv_UA');
  downloadPDFTable(table, NOMBRE_FICHERO, 'download-pdf_UA');
}
